import script from "./Mf.vue?vue&type=script&setup=true&lang=js"
export * from "./Mf.vue?vue&type=script&setup=true&lang=js"

import "./Mf.vue?vue&type=style&index=0&id=90db5808&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90db5808"]])

export default __exports__